import { Component, OnInit ,Input} from '@angular/core';
import{SeriviciogenericoService }from'../seriviciogenerico.service'

@Component({
  selector: 'app-modal-upload',
  templateUrl: './modal-upload.page.html',
  styleUrls: ['./modal-upload.page.scss'],
})
export class ModalUploadPage implements OnInit {
      // Data passed in by componentProps
      @Input() dataname: string;

  constructor(public seriviciogenerico:SeriviciogenericoService) { }

  ngOnInit() {
  }

  percentage = this.seriviciogenerico.uploadProgress


}
